import { RecordsTable } from 'dyl-components';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Row from './Row';

const Table = ({ onFilter, onPageChange, onSelectExternalNumber, onDelete, selectVerifyingPhone, selectedShared, selectedType, selectedForwarding, external_numbers, external_numbers_count, isReadingExternalNumbers, isPhoneTab }) => {
    const [params] = useSearchParams();

    return <RecordsTable
        tableBodyClassName='NumbersTable'
        isTableLoading={isReadingExternalNumbers}
        isSearchResultEmpty={!external_numbers_count && (params.get('search') || params.get('shared') || params.get('type') || params.get('user_id') || params.get('forwarding') || params.get('timeout_destination'))}
        isTableEmpty={!external_numbers_count && !(params.get('search') || params.get('shared') || params.get('type') || params.get('user_id') || params.get('forwarding') || params.get('timeout_destination'))}
        tableEmptyMessage='No Numbers Added'
        TableHeader={<Header onFilter={onFilter} count={external_numbers_count} numbers={external_numbers} selectedShared={selectedShared} selectedType={selectedType} selectedForwarding={selectedForwarding} isPhoneTab={isPhoneTab}/>}
        TableRows={external_numbers?.map?.((number) => <Row number={number} onSelectExternalNumber={onSelectExternalNumber} onDelete={onDelete} selectVerifyingPhone={selectVerifyingPhone} isPhoneTab={isPhoneTab}/>)}
        recordsCount={external_numbers_count}
        activePage={params.get('page')}
        onPageChange={onPageChange}
        recordsName='Number'
        hasPagination={!isPhoneTab}
    />
}

export default Table;